export default "__VITE_ASSET__BvBGTSq1__"